import { C as CosmosText$1, d as defineCustomElement$1 } from './p-BMLmP8GU.js';

const CosmosText = CosmosText$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosText, defineCustomElement };
